export default __webpack_public_path__ + "static/media/shoppage-package3.d77afa15.svg";